import { formatDate } from "simplydo/core/dates";
import { styled } from "simplydo/react/styled";

const Pill = styled.span<{ $contacted: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background: ${({ $contacted }) => ($contacted ? "#e6f4ea" : "#f1f3f5")};
  color: ${({ $contacted }) => ($contacted ? "#1e7b34" : "#5b6470")};

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }
`;

type ContactStatusPillProps = {
  contact?: { count?: number; lastContactedAt?: string | null };
};

/** Whether the organisation has emailed the company yet; green once it has. */
export const ContactStatusPill = ({ contact }: ContactStatusPillProps) => {
  const count = contact?.count ?? 0;
  if (!count) {
    return <Pill $contacted={false}>Not contacted</Pill>;
  }
  const last = contact?.lastContactedAt
    ? formatDate(contact.lastContactedAt, "MMM d, yyyy")
    : null;
  return (
    <Pill
      $contacted
      title={`Contacted ${count} ${count === 1 ? "time" : "times"}${last ? `, last on ${last}` : ""}`}
    >
      Contacted
    </Pill>
  );
};
